import BaseDataStore from '@/components/base/store/BaseDataStoreV1'
import i18n from '@/plugins/i18n'

const BaseConst = {
  version: 1,
  storeName: 'C1301ProjectCrowdFundPledge',
  serviceName: 'C1301ProjectCrowdFundPledgeService',

  //  if search -> search component
  componentDef: {
    form: {
      /*
       type: div, row, col, form, text,file,select, button,table
       component:  div,VRow,VForm AtTextField, AtSelect, AtBtn,AtDataTable
       rules :
          string.alpha , string.alpha_dash, string.alpha_num,string.alpha_spaces,string.length
          number.double, number.digits, number.integer, number.numeric,
          regular.email, regular.regex
          range.min , range.max, range.min_value, range.max_value , range.between , range.oneOf, range.excluded
          file.size , file.image , file.dimensions, file.mimes
          logic.confirmed, logic.is_not, logic.required, logic.required_if
      */
      viewDef: [
        {
          column: 'col-12',
          custom: 'ShippingForm'
        },
        {
          column: 'col-12',
          data: 'name',
          type: 'text',
          rules: 'required',
          label: i18n.t('c0101.form.name'),
          class: 'required',
          labelHint: i18n.t('c0101.formHints.name')
        },
        {
          column: 'col-12',
          data: 'phone',
          type: 'text',
          // not working
          //  input => input < 8 ? 'Please input `Valid Phone Number`' : true
          rules: ['required', 'integer'],
          label: i18n.t('c0101.form.phone'),
          class: 'required',
          labelHint: i18n.t('c0101.formHints.phone')
        },
        {
          column: 'col-12',
          data: 'address1',
          type: 'textarea',
          label: i18n.t('c0101.form.address'),
          rules: 'required',
          class: 'required',
          labelHint: i18n.t('c0101.formHints.address')
        },
        {
          column: 'col-12',
          data: 'address2',
          type: 'textarea',
          label: i18n.t('c0101.form.address2'),
          labelHint: i18n.t('c0101.formHints.address2')
        },
        {
          column: 'col-6',
          data: 'country',
          type: 'autoComplete',
          label: i18n.t('c0101.form.country'),
          props: {
            items: [],
            itemText: 'name',
            itemValue: 'id'
          },
          rules: 'required',
          class: 'required',
          labelHint: i18n.t('c0101.formHints.country')
        },
        {
          column: 'col-6',
          data: 'state',
          type: 'autoComplete',
          label: i18n.t('c0101.form.state'),
          props: {
            items: [],
            itemText: 'name',
            itemValue: 'id'
          },
          rules: 'required',
          class: 'required',
          labelHint: i18n.t('c0101.formHints.state')
        },
        {
          column: 'col-6',
          data: 'city',
          type: 'autoComplete',
          label: i18n.t('c0101.form.city'),
          props: {
            items: [],
            itemText: 'name',
            itemValue: 'id'
          },
          rules: 'required',
          class: 'required',
          labelHint: i18n.t('c0101.formHints.city')
        },
        {
          column: 'col-6',
          data: 'postcode',
          type: 'text',
          label: i18n.t('c0101.form.postCode'),
          rules: 'required',
          class: 'required',
          labelHint: i18n.t('c0101.formHints.postCode')
        }
      ],
      optionDef: {}
    }
  }
}
const C1301Const = new BaseDataStore(BaseConst)
export default C1301Const
